<div
    *ngIf="resourceForm.get('collaboration.enroll_approval_required.metadata.occasion_dates').hasError('required')"
></div>
<div
    *ngIf="
        resourceForm.get('collaboration.enroll_approval_required.metadata.occasion_dates')?.invalid &&
        (resourceForm.get('collaboration.enroll_approval_required.metadata.occasion_dates')?.dirty ||
            resourceForm.get('collaboration.enroll_approval_required.metadata.occasion_dates')?.touched)
    "
    class="error-message"
>
    <!-- <ng-container *ngIf="occasionDatesControl?.errors?.['occasionDates']">
      {{ occasionDatesControl.errors['occasionDates'] }}
    </ng-container> -->
</div>
<mat-expansion-panel #promoCodeExpansionPanel class="user-manage-course-expantion">
    <mat-expansion-panel-header>
        <mat-panel-title>
            <mat-icon>timer</mat-icon>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="3px">
                <span>{{ resourcenLabel }}</span>
                <span i18n="@@visibility">visibility</span>
            </div>
            <mat-icon
                class="icon-explain"
                matTooltip="Visibility determines the existence of the resource in the global search for all academies. When the resource Creator decides if you can see it in the K3 ecosystem, no matter if you have access to specific groups, learners, or the Academy. It's the Main switch for the K3 ecosystem."
                i18n-matTooltip
                >help_outline</mat-icon
            >
        </mat-panel-title>
        <mat-panel-description fxLayoutAlign="end center">
            <span
                matTooltip="Indicator of field change"
                i18n-matTooltip
                class="cell-indicator"
                [ngClass]="{ green: !resourceForm.value.always_available }"
            ></span>
        </mat-panel-description>
    </mat-expansion-panel-header>
    <div
        class="date-row-wrapper"
        fxFlex="100%"
        fxLayout="row"
        fxLayout.lt-md="column"
        fxLayoutAlign="space-between start"
        fxLayoutAlign.lt-md="center start"
        fxLayoutGap=".5em"
    >
        <mat-checkbox
            #time_open
            formControlName="always_available"
            color="primary"
            i18n="@@alwaysAvailable"
            class="always-available-check"
            >Always available
        </mat-checkbox>
        <div
            *ngIf="!resourceForm.value.always_available"
            class="date-row-wrapper"
            fxFlex="100%"
            fxLayout="row"
            fxLayout.lt-md="column"
            fxLayoutAlign="space-between center"
            fxLayoutAlign.lt-md="center start"
            fxLayoutGap=".5em"
        >
            <div class="date" fxFlex="grow" fxLayoutAlign="end center">
                <mat-form-field fxFlex="0 0 90%">
                    <input
                        matInput
                        formControlName="start_date"
                        [matDatepicker]="startDate"
                        placeholder="Start date"
                        i18n-placeholder="@@startDate"
                    />
                    <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
                    <mat-datepicker #startDate></mat-datepicker>
                </mat-form-field>
            </div>

            <div class="date" fxFlex="grow" fxLayoutAlign="end center">
                <mat-form-field fxFlex="0 0 90%">
                    <input
                        matInput
                        formControlName="end_date"
                        [matDatepicker]="endDate"
                        placeholder="End date"
                        i18n-placeholder="@@endDate"
                    />
                    <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
                    <mat-datepicker #endDate></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div
        class="date-error"
        *ngIf="
            !resourceForm.value.always_available &&
            !resourceForm.value.start_date &&
            !resourceForm.value.end_date &&
            resourceForm.value.publish
        "
        i18n
    >
        Start date and end date are required when the resource is published.
    </div>
</mat-expansion-panel>
<form [formGroup]="$any(resourceForm.get('collaboration'))" class="panel-body-wrapper collab-form">
    <mat-expansion-panel #expansionPanel class="user-manage-course-expantion">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <mat-icon>preview</mat-icon>
                <div i18n>Academy visibility</div>
                <mat-icon
                    class="icon-explain"
                    matTooltip="This determines when the resource information is available for the Academy, and who will be able to see and search for the resource, even if it is not open to take yet due to occasion dates settings or needs an enrollment to join. In short, it's the Academy Main Switch for visibility."
                    i18n-matTooltip
                    >help_outline</mat-icon
                >
            </mat-panel-title>
            <mat-panel-description fxLayoutAlign="end center">
                <span
                    matTooltip="Indicator of field is mandatory"
                    i18n-matTooltip
                    class="cell-indicator"
                    [ngClass]="{ green: !!resourceForm.value.collaboration?.view?.status }"
                ></span>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <ng-container [formGroup]="$any(resourceForm.get('collaboration').get('view'))">
            <div fxLayout="row" class="w-100" fxLayoutAlign="start center" fxLayoutGap="15px">
                <mat-radio-group
                    fxFlex="grow"
                    formControlName="status"
                    fxLayoutAlign="start center"
                    fxLayoutGap="70px"
                    fxLayoutGap.lt-sm="20px"
                    class="mt-1"
                >
                    <mat-radio-button [value]="true">
                        <span i18n>Yes</span>
                        <div
                            matTooltip="Permission has been denied to certain learners."
                            i18n-matTooltip
                            class="indicator-exclude"
                            *ngIf="
                                !resourceForm.get('collaboration.view').dirty &&
                                resourceForm.value.collaboration?.view?.status &&
                                resourceForm.value.collaboration?.view?.exclude
                            "
                        ></div>
                    </mat-radio-button>
                    <mat-radio-button [value]="false">
                        <span i18n>No</span>
                        <div
                            matTooltip="Permission has been granted to certain learners."
                            i18n-matTooltip
                            class="indicator-exclude green"
                            *ngIf="
                                !resourceForm.get('collaboration.view').dirty &&
                                !resourceForm.value.collaboration?.view?.status &&
                                resourceForm.value.collaboration?.view?.exclude
                            "
                        ></div>
                    </mat-radio-button>
                </mat-radio-group>

                <button
                    type="button"
                    matTooltip="Manage excluding"
                    i18n-matTooltip
                    class="specify-btn"
                    mat-icon-button
                    (click)="editResourceAccessPermision('view', resourceForm.value.collaboration.view)"
                >
                    <mat-icon>rule</mat-icon>
                </button>
            </div>
        </ng-container>
    </mat-expansion-panel>

    <mat-expansion-panel #expansionPanel class="user-manage-course-expantion enrollment-periods">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <mat-icon>play_circle</mat-icon>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="3px">
                    <span>{{ resourcenLabel }}</span>
                    <span i18n>Occasion periods</span>
                </div>
                <mat-icon
                    class="icon-explain"
                    matTooltip="Alter resource occasion dates for the Academy."
                    i18n-matTooltip
                    >help_outline</mat-icon
                >
            </mat-panel-title>
            <mat-panel-description fxLayoutAlign="end center">
                <span
                    matTooltip="Indicator of field is mandatory"
                    i18n-matTooltip
                    class="cell-indicator"
                    [ngClass]="{
                        green: !!resourceForm.value.collaboration?.enroll_approval_required?.metadata
                            ?.occasion_always_open
                    }"
                ></span>
            </mat-panel-description>
        </mat-expansion-panel-header>

        <div fxLayout="row" class="w-100" fxLayoutAlign="start start" fxLayoutGap="15px">
            <div fxLayout="row" class="w-100" fxLayoutAlign="start center" fxLayoutGap="15px">
                <mat-checkbox
                    #time_open
                    [formControl]="
                        $any(resourceForm.get('collaboration.enroll_approval_required.metadata.occasion_always_open'))
                    "
                    color="primary"
                    i18n="@@alwaysOpen"
                    class="always-available-check"
                    >Always Open
                </mat-checkbox>
            </div>
            <ng-container
                [ngTemplateOutlet]="occasionsManager"
                [ngTemplateOutletContext]="{
                    displayedDates: 'occasions'
                }"
            ></ng-container>
        </div>
    </mat-expansion-panel>
    <mat-expansion-panel #expansionPanel class="user-manage-course-expantion enrollment-periods">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <mat-icon>app_registration</mat-icon>
                <div i18n>Enrollment Approvals & Periods</div>
                <mat-icon
                    class="icon-explain"
                    matTooltip="Manage Enrollment Approvals and Periods of the resource"
                    i18n-matTooltip
                    >help_outline</mat-icon
                >
            </mat-panel-title>
            <mat-panel-description fxLayoutAlign="end center">
                <span
                    matTooltip="Indicator of field is mandatory"
                    i18n-matTooltip
                    class="cell-indicator"
                    [ngClass]="{
                        green: !!resourceForm.value.collaboration?.enroll_approval_required?.status
                    }"
                ></span>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <ng-container [formGroup]="$any(resourceForm.get('collaboration').get('enroll_approval_required'))">
            <div fxLayout="column" class="w-100" fxLayoutAlign="start start" fxLayoutGap="15px">
                <div fxLayout="row" class="w-100" fxLayoutAlign="start center" fxLayoutGap="15px">
                    <mat-radio-group
                        fxFlex="grow"
                        formControlName="status"
                        fxLayoutAlign="start center"
                        fxLayoutGap="25px"
                        fxLayoutGap.lt-sm="20px"
                        class="w-100"
                    >
                        <mat-radio-button [value]="true">
                            <span i18n>Yes</span>
                            <div
                                matTooltip="Permission has been denied to certain learners."
                                i18n-matTooltip
                                class="indicator-exclude"
                                *ngIf="
                                    !resourceForm.get('collaboration.enroll_approval_required').dirty &&
                                    resourceForm.value.collaboration?.enroll_approval_required?.status &&
                                    resourceForm.value.collaboration?.enroll_approval_required?.exclude
                                "
                            ></div>
                        </mat-radio-button>
                        <mat-radio-button [value]="false">
                            <span i18n>No</span>
                            <div
                                matTooltip="Permission has been granted to certain learners."
                                i18n-matTooltip
                                class="indicator-exclude green"
                                *ngIf="
                                    !resourceForm.get('collaboration.enroll_approval_required').dirty &&
                                    !resourceForm.value.collaboration?.enroll_approval_required?.status &&
                                    resourceForm.value.collaboration?.enroll_approval_required?.exclude
                                "
                            ></div>
                        </mat-radio-button>
                    </mat-radio-group>

                    <button
                        type="button"
                        matTooltip="Manage excluding"
                        i18n-matTooltip
                        class="specify-btn"
                        mat-icon-button
                        (click)="
                            editResourceAccessPermision(
                                'enroll_approval_required',
                                resourceForm.value.collaboration.enroll_approval_required
                            )
                        "
                    >
                        <mat-icon>rule</mat-icon>
                    </button>
                </div>
                <ng-container
                    [ngTemplateOutlet]="occasionsManager"
                    [ngTemplateOutletContext]="{
                        displayedDates: 'enrollment'
                    }"
                ></ng-container>
            </div>
        </ng-container>
    </mat-expansion-panel>
    <mat-expansion-panel #expansionPanel class="user-manage-course-expantion">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <mat-icon>priority_high</mat-icon>
                <div i18n>Mandatory</div>
                <mat-icon class="icon-explain" matTooltip="Make Mandatory for Academy" i18n-matTooltip
                    >help_outline</mat-icon
                >
            </mat-panel-title>
            <mat-panel-description fxLayoutAlign="end center">
                <span
                    matTooltip="Indicator of field is mandatory"
                    i18n-matTooltip
                    class="cell-indicator"
                    [ngClass]="{ green: !!resourceForm.value.collaboration?.mandatory?.status }"
                ></span>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <ng-container [formGroup]="$any(resourceForm.get('collaboration').get('mandatory'))">
            <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="15px">
                <mat-radio-group
                    fxFlex="grow"
                    formControlName="status"
                    fxLayoutAlign="start center"
                    fxLayoutGap="70px"
                    fxLayoutGap.lt-sm="20px"
                    class="mt-1"
                >
                    <mat-radio-button [value]="true">
                        <span i18n>Yes</span>
                        <div
                            matTooltip="Permission has been denied to certain learners."
                            i18n-matTooltip
                            class="indicator-exclude"
                            *ngIf="
                                !resourceForm.get('collaboration.mandatory').dirty &&
                                resourceForm.value.collaboration?.mandatory?.status &&
                                resourceForm.value.collaboration?.mandatory?.exclude
                            "
                        ></div>
                    </mat-radio-button>
                    <mat-radio-button [value]="false">
                        <span i18n>No</span>
                        <div
                            matTooltip="Permission has been granted to certain learners."
                            i18n-matTooltip
                            class="indicator-exclude green"
                            *ngIf="
                                !resourceForm.get('collaboration.mandatory').dirty &&
                                !resourceForm.value.collaboration?.mandatory?.status &&
                                resourceForm.value.collaboration?.mandatory?.exclude
                            "
                        ></div>
                    </mat-radio-button>
                </mat-radio-group>

                <ng-container *ngIf="customer">
                    <button
                        [ngClass]="{ green: !!resource?.recurring?.recurring }"
                        *ngIf="!!resourceForm.value.collaboration?.mandatory?.status && customer.division_mode"
                        type="button"
                        matTooltip="Update recurring"
                        i18n-matTooltip
                        class="specify-btn"
                        mat-icon-button
                        (click)="onUpdateResRecurring.emit(customer.id)"
                    >
                        <mat-icon class="material-icons-outlined">event_repeat</mat-icon>
                    </button>
                </ng-container>
                <button
                    type="button"
                    matTooltip="Manage excluding"
                    i18n-matTooltip
                    class="specify-btn"
                    mat-icon-button
                    (click)="editResourceAccessPermision('mandatory', resourceForm.value.collaboration.mandatory)"
                >
                    <mat-icon>rule</mat-icon>
                </button>
            </div>
        </ng-container>
    </mat-expansion-panel>
    <mat-expansion-panel #expansionPanel class="user-manage-course-expantion">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <mat-icon>assignment_turned_in</mat-icon>
                <div i18n>Approval /Sign off</div>
                <mat-icon
                    class="icon-explain"
                    matTooltip="Learners Signoff and get approved by an authorized administrator"
                    i18n-matTooltip
                    >help_outline</mat-icon
                >
            </mat-panel-title>
            <mat-panel-description fxLayoutAlign="end center">
                <span
                    matTooltip="Indicator of field is mandatory"
                    i18n-matTooltip
                    class="cell-indicator"
                    [ngClass]="{
                        green: !!resourceForm.value.collaboration?.signoff_required?.status
                    }"
                ></span>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <ng-container [formGroup]="$any(resourceForm.get('collaboration').get('signoff_required'))">
            <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="15px">
                <mat-radio-group
                    fxFlex="grow"
                    formControlName="status"
                    fxLayoutAlign="start center"
                    fxLayoutGap="25px"
                    fxLayoutGap.lt-sm="20px"
                    class="mt-1"
                >
                    <mat-radio-button [value]="true">
                        <span i18n>Yes</span>
                        <div
                            matTooltip="Permission has been denied to certain learners."
                            i18n-matTooltip
                            class="indicator-exclude"
                            *ngIf="
                                !resourceForm.get('collaboration.signoff_required').dirty &&
                                resourceForm.value.collaboration?.signoff_required?.status &&
                                resourceForm.value.collaboration?.signoff_required?.exclude
                            "
                        ></div>
                    </mat-radio-button>
                    <mat-radio-button [value]="false">
                        <span i18n>No</span>
                        <div
                            matTooltip="Permission has been granted to certain learners."
                            i18n-matTooltip
                            class="indicator-exclude green"
                            *ngIf="
                                !resourceForm.get('collaboration.signoff_required').dirty &&
                                !resourceForm.value.collaboration?.signoff_required?.status &&
                                resourceForm.value.collaboration?.signoff_required?.exclude
                            "
                        ></div>
                    </mat-radio-button>
                </mat-radio-group>

                <button
                    type="button"
                    matTooltip="Manage excluding"
                    i18n-matTooltip
                    class="specify-btn"
                    mat-icon-button
                    (click)="
                        editResourceAccessPermision(
                            'signoff_required',
                            resourceForm.value.collaboration.signoff_required
                        )
                    "
                >
                    <mat-icon>rule</mat-icon>
                </button>
            </div>
        </ng-container>
    </mat-expansion-panel>
</form>

<ng-template #occasionsManager let-displayedDates="displayedDates">
    <app-occasions-dates-manager
        [dateOccasions]="resourceOccasions"
        [alwaysOpenControl]="
            $any(resourceForm.get('collaboration.enroll_approval_required.metadata.occasion_always_open'))
        "
        [displayedDates]="displayedDates"
    ></app-occasions-dates-manager>
</ng-template>
